import { render } from "./CloseIcon.vue?vue&type=template&id=aac954b8&scoped=true"
const script = {}

import "./CloseIcon.vue?vue&type=style&index=0&id=aac954b8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac954b8"]])

export default __exports__